export default __webpack_public_path__ + "static/media/Hiawatha art logo.18d2006e.png";